import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureStore
export interface IFeatureStore extends IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_STORE_DEFAULT
export const _FEATURE_STORE_DEFAULT: Readonly<IFeatureStore & Object> = {
  displayText: NavigationPageEnumHumanReadable.Store,
  feature: NavigationPageEnum.Store,
  ref: SettingsReferenceEnum.undefined,
  standalone: false,
};
//#endregion